import React, { type ReactNode } from "react";
import { ErrorGlobal, Loader } from "src/components";
import { REACT_QUERY_STALE_TIME } from "src/constants";
import { useGetAccountQuery } from "src/graphql/generated/queries";
import { useCurrentCustomerQuery, useUuid } from "src/hooks";
import { useAuthStore } from "src/stores/auth-store";

export const CurrentAccountWrapper = ({
  children,
}: {
  children: ReactNode;
}) => {
  const uuid = useUuid();
  const logout = useAuthStore((state) => state.logout);
  const {
    isInitialLoading: isCurrentCustomerLoading,
    errorUpdatedAt: currentCustomerErrorUpdatedAt,
  } = useCurrentCustomerQuery();
  // Only a lookup that never answered holds the pages back: a disabled one never
  // starts, and a refetch after a profile update, even of a failed lookup, keeps them
  // mounted.
  const isCurrentCustomerFirstLoad =
    isCurrentCustomerLoading && currentCustomerErrorUpdatedAt === 0;

  const { data, isLoading, error } = useGetAccountQuery(
    {
      uuid,
    },
    {
      staleTime: REACT_QUERY_STALE_TIME,
    },
  );

  if (error) {
    return <ErrorGlobal onLogout={logout} />;
  }

  if (isLoading || isCurrentCustomerFirstLoad || !data) {
    return <Loader />;
  }

  return <>{children}</>;
};
